import { render, staticRenderFns } from "./MainTitle.vue?vue&type=template&id=f4030914&scoped=true"
var script = {}
import style0 from "./MainTitle.vue?vue&type=style&index=0&id=f4030914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4030914",
  null
  
)

export default component.exports